import template from './breadcrumb-navigation.template.html';
import './breadcrumb-navigation.scss';

export default {
  template,
  bindings: {
    breadcrumbs: '<',
    onBreadcrumbClick: '&',
  },
};



// WEBPACK FOOTER //
// ./src/app/shared/breadcrumb/breadcrumb-navigation/breadcrumb-navigation.component.js